import React, { useEffect } from "react"
import { Input, Button } from "reactstrap"

const InvoiceItemRow = ({ rows, ProductArray, onDelete, onEdit ,BrandArr,WeightCategory}) => {
  useEffect(() => {
    console.log(ProductArray,'ProductArray')
  }, [ProductArray])
  return rows.map((row, index) => {
    const product = ProductArray && ProductArray[index] && ProductArray[index].find(item => item.Id == row.F_ItemMaster)
    const SGST = product ? product.IGST / 2 : 0
    const CGST = product ? product.IGST / 2 : 0

    return (
      <tr key={index}>
        <td>
          <Input
            type="select"
            value={row.F_BrandMaster || ""}
            onChange={e => onEdit(index, "F_BrandMaster", e.target.value)}
          >
            <option value="">Select Brand</option>
            {BrandArr && BrandArr.map(item => (
              <option key={item.Id} value={item.Id}>
                {item.Name}
              </option>
            ))}
          </Input>
        </td>
        <td>
          <Input
            type="select"
            value={row.F_WeightCategory || ""}
            onChange={e => onEdit(index, "F_WeightCategory", e.target.value)}
          >
            <option value="">Select Weight Category : </option>
            {WeightCategory && WeightCategory.map(item => (
              <option key={item.Id} value={item.Id}>
                {item.Name}
              </option>
            ))}
          </Input>
        </td>
        <td>
          <Input
            type="select"
            value={row.F_ItemMaster || ""}
            onChange={e => onEdit(index, "F_ItemMaster", e.target.value)}
          >
            <option value="">Select Item</option>
            {ProductArray && ProductArray[index] && ProductArray[index].map(item => (
              <option key={item.Id} value={item.Id}>
                {item.Name}
              </option>
            ))}
          </Input>
        </td>
        <td>
          <Input
            type="number"
            value={row.Quantity || 0}
            onFocus={(e) => e.target.select()}
            min="1" // Set minimum value to 1
            onChange={e => {
              const value = Math.max(1, e.target.value) // Ensure value is at least 1
              onEdit(index, "Quantity", value)
            }}
          />
        </td>
        <td>
          <Input
            type="number"
            value={row.Rate || 0}
            onChange={e => onEdit(index, "Rate", e.target.value)}
          />
        </td>
       
        <td>{row.Total || 0}</td>
        <td>
          <Input
            type="number"
            value={row.Discount || 0}
            onChange={e => onEdit(index, "Discount", e.target.value)}
          />
        </td>
        <td>{SGST || 0}</td>
        <td>{CGST || 0}</td>
        <td>{product ? product.IGST : 0}</td>
        <td>
          <Button color="danger" onClick={() => onDelete(index)}>
            Delete
          </Button>
        </td>
      </tr>
    )
  })
}

export default InvoiceItemRow
